<template>
    <div class="d-flex flex-column nav-items">
        <NuxtLink
            v-for="step in visibleSteps"
            :key="step.name"
            class="nav-item"
            :to="{
                path: $localePath({name: 'booking-id-' + step.name}),
                query: $route.query
            }"
            :class="{'disabled': step.disabled}">
            <div class="menu-items">
                <font-awesome-icon
                    :icon="menuIcons[step.name]"
                    fixed-width />
                <span>
                    {{ $t('menu.' + step.name) }}
                </span>
            </div>
        </NuxtLink>
    </div>
</template>

<script>

import bookingStepsAndValidationMixin from "@/mixins/bookingStepsAndValidationMixin";

export default {
    name: "RegistrationMenu",
    mixins: [bookingStepsAndValidationMixin],
    data() {
        return {
            menuIcons: {
                'bookingStart': 'play',
                'calendar': 'calendar',
                'bookings': 'calendar-day',
                'general': 'id-card',
                'overview': 'check',
                'payment': 'coins'
            }
        }
    },
    computed: {
        visibleSteps() {
            return this.getBookingSteps?.filter(step => !step.hidden)
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:map";

.nav-items > * {
    margin-bottom: map.get($spacers, 2);
}

.nav-item {
    color: var(--custom-text-color, $nav-item-color);
    font-size: $font-size-base;
    padding: map.get($spacers, 1) map.get($spacers, 3);
    user-select: none;

    > span {
        margin-left: map.get($spacers, 1);
    }
}

.nav-item.nuxt-link-active {
    background: $gray-400;
    border-radius: 0.375rem;
    color: var(--custom-heading-color, $nav-item-hover-color) !important;
}

.nav-item:hover {
    color: var(--custom-heading-color, $nav-item-hover-color);
}

.nav-item.disabled {
    color: color-mix(in srgb, var(--custom-text-color, $nav-item-color) 45%, transparent);
    pointer-events: none;
}

.menu-items > :nth-child(2) {
    margin-left: map.get($spacers, 2);
}
</style>